export class DataKepesantrenan {
  id: number | null;
  userId: number;
  namaPesantren: string;
  nsp: string;
  alamat: string;
  provinsiId: number;
  kabupatenId: number;
  kecamatanId: number;
  peran: string;
  tahunBergabung: number;
  statusMukim: number | null;

  constructor(
    id: number | null,
    userId: number,
    namaPesantren: string,
    nsp: string,
    alamat: string,
    provinsiId: number,
    kabupatenId: number,
    kecamatanId: number,
    peran: string,
    tahunBergabung: number,
    statusMukim: number | null,
  ) {
    this.id = id;
    this.userId = userId;
    this.namaPesantren = namaPesantren;
    this.nsp = nsp;
    this.alamat = alamat;
    this.provinsiId = provinsiId;
    this.kabupatenId = kabupatenId;
    this.kecamatanId = kecamatanId;
    this.peran = peran;
    this.tahunBergabung = tahunBergabung;
    this.statusMukim = statusMukim;
  }
}
